__webpack_require__.p = "/etogy-challenge/";